export default __webpack_public_path__ + "static/media/about.176f2d44.mp4";